"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertGoogleDocToHTML = exports.convertGoogleToHTML = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _immutable = require("immutable");

var _draftConvert = require("draft-convert");

var _Url2 = _interopRequireDefault(require("urlinator/Url"));

var styles = {
  BOLD: '700',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  STRIKETHROUGH: 'line-through',
  SUPERSCRIPT: 'super',
  SUBSCRIPT: 'sub'
};
var elements = {
  ANCHOR: 'a',
  BOLD: 'strong',
  ITALIC: 'em',
  UNDERLINE: 'u',
  STRIKETHROUGH: 'del',
  SUPERSCRIPT: 'sup',
  SUBSCRIPT: 'sub',
  H2: 'h2',
  H3: 'h3'
};

var HEADERS = _immutable.Set.of('H1', 'H2', 'H3', 'H4', 'H5', 'H6');

var LISTS = _immutable.Set.of('OL', 'UL', 'LI');

var TABLES = _immutable.Set.of('TR', 'TD', 'TABLE');

var NON_TEXT_MEDIA = _immutable.Set.of('IMG', 'VIDEO', 'FIGURE');

var CHILD_NODES_OVERRIDES = _immutable.Set.of('P').union(HEADERS).union(LISTS).union(TABLES);

var COMMENT_HREF = /^#cmnt_ref\d+|#cmnt\d+/;
var GOOGLE_REDIRECT = /^https?:\/\/www.google.com\/url\?/;
var LIST_CLASS_PATTERN = /lst-kix_(\w*)-(\d*)/;
var listMap = (0, _immutable.Map)();

var badHref = function badHref(href) {
  return COMMENT_HREF.test(href);
};

var removeGoogleRedirect = function removeGoogleRedirect(href) {
  if (GOOGLE_REDIRECT.test(href)) {
    var _Url = new _Url2.default(href),
        params = _Url.params;

    return params.q || href;
  }

  return href;
};
/**
 * this is the internal version of https://www.github.com/aem/docs-soap
 */


var isCommentsStyle = function isCommentsStyle(_ref) {
  var border = _ref.border,
      margin = _ref.margin;
  return border.indexOf('1px') !== -1 && border.indexOf('solid') !== -1 && border.indexOf('black') !== -1 && margin === '5px';
};

var isCommentStyle = function isCommentStyle(_ref2) {
  var color = _ref2.color,
      fontFamily = _ref2.fontFamily,
      fontSize = _ref2.fontSize,
      lineHeight = _ref2.lineHeight,
      margin = _ref2.margin,
      padding = _ref2.padding,
      textAlign = _ref2.textAlign;
  return color === 'rgb(0, 0, 0)' && fontFamily === 'Arial' && fontSize === '11pt' && lineHeight === '1' && margin === '0px' && padding === '0px' && textAlign === 'left';
};

var childrenHaveCommentStyle = function childrenHaveCommentStyle(_ref3) {
  var childNodes = _ref3.childNodes;

  for (var i = 0; i < childNodes.length; i++) {
    if (!isCommentStyle(childNodes[i].style)) {
      return false;
    }
  }

  return true;
};

var wrapNodeAnchor = function wrapNodeAnchor(node, href) {
  if (badHref(href)) {
    return document.createElement('span');
  }

  var anchor = document.createElement('a');
  anchor.href = removeGoogleRedirect(href);
  anchor.appendChild(node.cloneNode(true));
  return anchor;
};

var wrapNodeInline = function wrapNodeInline(node, style) {
  var el = document.createElement(style);
  el.appendChild(node.cloneNode(true));
  return el;
};

var wrapNode = function wrapNode(inner, result) {
  var newNode = result.cloneNode(true);

  if (!inner) {
    return newNode;
  }

  if (inner.style && inner.style.fontWeight === styles.BOLD) {
    newNode = wrapNodeInline(newNode, elements.BOLD);
  }

  if (inner.style && inner.style.fontStyle === styles.ITALIC) {
    newNode = wrapNodeInline(newNode, elements.ITALIC);
  }

  if (inner.style && inner.style.textDecoration === styles.UNDERLINE) {
    newNode = wrapNodeInline(newNode, elements.UNDERLINE);
  }

  if (inner.style && inner.style.textDecoration === styles.STRIKETHROUGH) {
    newNode = wrapNodeInline(newNode, elements.STRIKETHROUGH);
  }

  if (inner.style && inner.style.verticalAlign === styles.SUPERSCRIPT) {
    newNode = wrapNodeInline(newNode, elements.SUPERSCRIPT);
  }

  if (inner.style && inner.style.verticalAlign === styles.SUBSCRIPT) {
    newNode = wrapNodeInline(newNode, elements.SUBSCRIPT);
  }

  return newNode;
};
/**
 * Takes a block-level element (paragraphs and bullets) and applies inline styles as necessary
 */


var applyBlockStyles = function applyBlockStyles(dirty) {
  var node = dirty.cloneNode(true);
  var newNode = document.createTextNode(node.textContent);
  var styledNode;
  var anchorNode;

  if (node.childNodes[0]) {
    if (node.childNodes[0].childNodes && node.childNodes[0].childNodes[0] && (node.childNodes[0].childNodes[0].nodeName === 'A' || node.childNodes[0].childNodes[0].nodeName === 'IMG')) {
      anchorNode = node.childNodes[0].childNodes[0];
    } else if (node.childNodes[0].nodeName === 'A' || node.childNodes[0].nodeName === 'IMG') {
      anchorNode = node.childNodes[0];
    }

    if (anchorNode) {
      if (anchorNode.nodeName === 'A') {
        newNode = wrapNodeAnchor(newNode.cloneNode(true), anchorNode.href);
      } else if (anchorNode.nodeName === 'IMG') {
        newNode = anchorNode;
      }

      styledNode = anchorNode.childNodes[0];
    } else if (node.className === 'title') {
      newNode = wrapNodeInline(newNode, elements.H2);
    } else if (node.className === 'subtitle') {
      newNode = wrapNodeInline(newNode, elements.H3);
    } else if (node.childNodes[0].style) {
      styledNode = node.childNodes[0];
    }
  }

  newNode = wrapNode(styledNode, newNode);
  return newNode;
};
/**
 * parse out the inline style properties and wrap the text in HTML elements instead
 */


var applyInlineStyles = function applyInlineStyles(dirty) {
  var node = dirty.cloneNode(true);
  var newNode = document.createTextNode(node.textContent);
  var styledNode = node;
  var anchorNode;

  if (node.childNodes && node.childNodes[0] && node.childNodes[0].nodeName === 'A') {
    anchorNode = node.childNodes[0];
  } else if (node.nodeName === 'A') {
    anchorNode = node;
  }

  if (anchorNode) {
    newNode = wrapNodeAnchor(newNode.cloneNode(true), anchorNode.href);

    if (anchorNode.childNodes[0] && anchorNode.childNodes[0].style) {
      styledNode = anchorNode.childNodes[0];
    }
  }

  newNode = wrapNode(styledNode, newNode);
  return newNode;
};

var handleExportedLists = function handleExportedLists(className, newNode, newWrapper) {
  var listClasses = LIST_CLASS_PATTERN.exec(className);

  if (listClasses) {
    var _listClasses = (0, _slicedToArray2.default)(listClasses, 3),
        key = _listClasses[1],
        depth = _listClasses[2];

    if (className.indexOf('start') !== -1) {
      newWrapper.appendChild(newNode);

      if (listMap.get(key)) {
        listMap = listMap.setIn([key, depth], newWrapper);
        listMap.getIn([key, "" + (depth - 1)]).appendChild(newWrapper);
        return true;
      } // depth 0 -> make new entry AND allow node to be added to main nodes (entry point of this list)


      listMap = listMap.set(key, (0, _immutable.Map)((0, _defineProperty2.default)({}, depth, newWrapper)));
      return false;
    }

    listMap.getIn([key, depth]).appendChild(newNode);
    return true;
  }

  return false;
};

var parseList = function parseList(node) {
  var className = node.className,
      childNodes = node.childNodes,
      nodeName = node.nodeName;
  var newWrapper = document.createElement(nodeName);
  var newNode = document.createDocumentFragment();
  var items = (0, _immutable.List)();

  for (var i = 0; i < childNodes.length; i++) {
    var _items;

    /* eslint-disable no-use-before-define */
    items = (_items = items).push.apply(_items, (0, _toConsumableArray2.default)(getCleanNode(childNodes[i])));
    /* eslint-enable no-use-before-define */
  }

  items.map(function (i) {
    return newNode.appendChild(i);
  });

  if (handleExportedLists(className, newNode, newWrapper)) {
    return [];
  }

  newWrapper.appendChild(newNode);
  return [newWrapper];
};

var getCleanNode = function getCleanNode(node) {
  // recursive base case: 0 or 1 child nodes, we always know how to handle this case
  if (node.childNodes && (node.childNodes.length <= 1 || CHILD_NODES_OVERRIDES.has(node.nodeName) || node.nodeName === 'DIV' && isCommentsStyle(node.style))) {
    if (NON_TEXT_MEDIA.has(node.nodeName)) {
      return [node];
    }

    var newWrapper = null; // create a new target node

    var newNode = document.createTextNode(node.textContent);

    if (LISTS.has(node.nodeName) || TABLES.has(node.nodeName) || HEADERS.has(node.nodeName)) {
      return parseList(node);
    } else if (node.nodeName === 'P') {
      // Google is pretty consistent about new paragraphs in <p></p> tags tho...
      if (node.childNodes.length > 1) {
        return parseList(node);
      }

      newWrapper = document.createElement('p');
      newNode = applyBlockStyles(node);
    } else if (node.nodeName === 'BR') {
      newNode = node;
    } else if (node.nodeName === 'DIV' && isCommentsStyle(node.style) && childrenHaveCommentStyle(node)) {
      return [];
    } else if (node.childNodes.length === 1 && node.childNodes[0].nodeName !== '#text') {
      // there is a nontrivial (i.e. non-text) child we should drill down to
      return getCleanNode(node.childNodes[0]);
    } else {
      // everything else is a span I guess
      newWrapper = document.createElement('span');
      newNode = applyInlineStyles(node);
    }

    if (newWrapper) {
      newWrapper.appendChild(newNode);
      return [newWrapper];
    } // if it's nothing that we want to specifically handle in the composer just return the node,
    // draft-js will clean it up for us


    return [node.cloneNode(true)];
  }

  if (node.childNodes) {
    var nodes = [];

    for (var i = 0; i < node.childNodes.length; i++) {
      nodes.push.apply(nodes, (0, _toConsumableArray2.default)(getCleanNode(node.childNodes[i])));
    }

    return nodes;
  }

  return [node];
};

var shouldKeepNode = function shouldKeepNode(node) {
  // Windows clipboards append the <!--StartFragment--> and <!--EndFragment--> which we don't want
  if (node.nodeName === '#comment') {
    return false;
  } // Windows clipboards seem to insert a stray space character at the start and end of body tag


  if (node.nodeName === '#text' && node.parentNode.nodeName === 'BODY' && (node.previousSibling === null && node.nextSibling || node.previousSibling && node.nextSibling === null)) {
    return false;
  }

  return true;
};

var getCleanDocument = function getCleanDocument(dirty) {
  var body = document.createElement('body');
  var nodes = dirty.childNodes;
  var cleanNodes = new _immutable.List();

  for (var i = 0; i < nodes.length; i++) {
    if (shouldKeepNode(nodes[i])) {
      var _cleanNodes;

      cleanNodes = (_cleanNodes = cleanNodes).push.apply(_cleanNodes, (0, _toConsumableArray2.default)(getCleanNode(nodes[i])));
    }
  }

  cleanNodes.map(function (node) {
    return body.appendChild(node.cloneNode(true));
  });
  listMap = listMap.clear();
  return body;
};

var convertGoogleToHTML = function convertGoogleToHTML(clipboardContent) {
  (0, _invariant.default)(typeof clipboardContent === 'string', "Expected 'clipboardContent' to be a string of HTML, received " + typeof clipboardContent);
  (0, _invariant.default)(clipboardContent.length > 0, 'Expected clipboardContent to have content, received empty string');
  return getCleanDocument((0, _draftConvert.parseHTML)(clipboardContent.replace(/(\r\n|\n|\r)/, ''))).outerHTML;
};

exports.convertGoogleToHTML = convertGoogleToHTML;

var convertGoogleDocToHTML = function convertGoogleDocToHTML(doc) {
  return convertGoogleToHTML(doc);
};

exports.convertGoogleDocToHTML = convertGoogleDocToHTML;